<template>
  <v-app>
    
    <Header v-if="!printPage" :darkMode="darkMode" @update:darkMode="darkMode = $event" />
    
    <v-main>
      <v-container fluid>
        <router-view @authenticated="session.getAuthenticated() == 'true'" />
      </v-container>
    </v-main>

    <notifications position="bottom right" group="appWarning" />

    <span v-if="!printPage" class="fixed left-4 bottom-4 simulation-ver">
      {{ session.getExamVisibility("FALSE") ? "Sim." : "Exam." }}
      {{ buildDate }}
    </span>

    <v-speed-dial class="no-print" v-if="!isOnExam() && !printPage" v-model="fab" :direction="'top'" fixed right bottom>
      <template v-slot:activator>
        <v-btn v-model="fab" fab color="primary">
          <v-icon v-if="fab"> mdi-close </v-icon>
          <v-icon v-else> mdi-earth </v-icon>
        </v-btn>
      </template>
      <v-btn v-for="(value, key, index) in {
        en: 'EN',
        ro: 'RO',
        fr: 'FR',
      }" :key="index" :value="key" @click="changeLanguage($event)" fab dark small>
        {{ value }}
      </v-btn>
    </v-speed-dial>
    
  </v-app>
</template>

<script>
import "@/assets/main.css";
import { exam } from "@/js/exam";
import { prepareExam } from "@/js/prepareExam";
import { session } from "@/js/session";
import Header from "@/components/Header"

export default {
  name: "App",
  components: { Header },
  props: {
    langs: [
      {
        value: "ro",
        image: "@/assets/50-px-romanian-flag-icon.png",
      },
      {
        value: "en",
        image: "@/assets/50-px-united-kingdom-flag-icon.png",
      }
    ],
  },
  data() {
    return {
      exam,
      session,
      showMenu: false,
      prepareExam,
      fab: false,
      printPage:false,
      darkMode: JSON.parse(localStorage.getItem('darkMode')) || false
    };
  },
  watch: {
    darkMode(newVal) {
      this.$vuetify.theme.dark = newVal;
      localStorage.setItem('darkMode', JSON.stringify(newVal));
    },
    $route(to, from){
      this.printPage = to.name == "AdminExamPrint";
    }
  },
  methods: {
    changeLanguage(event) {
      this.language = event.currentTarget.value;
    },
    logout() {
      this.$set(session.setCookie, "authenticated", false);
      this.$set(session.setCookie, "userId", 0);
      session.logout();
    },
    isOnExam() {
      return (
        this.session.getAuthenticated() == "true" &&
        ((this.$route.name == "Exam" && !this.exam.examEnded) ||
          (this.$route.name == "PrepareExam" &&
            (prepareExam.preparedExam || prepareExam.loading)))
      );
    },
    toggle() {
      this.updateMenu(!this.showMenu);
    },
    updateMenu(val) {
      const element = document.getElementById("navbar-sticky");
      if (val) {
        element.classList.remove("hidden");
      } else {
        element.classList.add("hidden");
      }
      this.showMenu = val;
    },
  },

  created() {
    this.$vuetify.theme.dark = this.darkMode;

    if (window.location.search == process.env.VUE_APP_ROOT_forceLogOut) {
      this.$router.push(this.$route.path);

      session.logout();
    }
  },
  mounted() {
    this.session.setAuthenticated();
    this.session.setAuthorization();

    if (localStorage.getItem("authenticated") == "false") {
      /* this.$router.go({ name: 'Login' });*/
    }

    exam.userId = session.userId;
    session.mounted();

    if (
      sessionStorage.getItem("VUE_APP_ROOT_inspect") ==
      process.env.VUE_APP_ROOT_inspect ||
      session.isTeacher() ||
      session.isAdmin()
    ) {
    } else {
      document.body.classList.add("unselectable");
    }
  },
  computed: {
    language: {
      get: function () {
        return localStorage.getItem("language");
      },
      set: function (newVal) {
        localStorage.setItem("language", newVal);
        localStorage.setItem("languagePicked", "true");
        this.$i18n.locale = newVal;
        this.$vuetify.lang.current = newVal;
      },
    },
    buildDate() {
      return process.env.VUE_APP_BUILD_DATE;
    },
  },
};

// ### RESTRICT ACCESS TO DEVTOOLS AND CONTEXT MENU ###
// document.addEventListener("contextmenu", function (e) {
//   if (
//     process.env.VUE_APP_ROOT_inspect == window.location.search ||
//     session.isTeacher() ||
//     session.isAdmin()
//   ) {
//     sessionStorage.setItem("VUE_APP_ROOT_inspect", process.env.VUE_APP_ROOT_inspect);
//     document.body.classList.remove("unselectable");
//   }

//   if (
//     sessionStorage.getItem("VUE_APP_ROOT_inspect") == process.env.VUE_APP_ROOT_inspect ||
//     session.isTeacher() ||
//     session.isAdmin()
//   ) {
//   } else e.preventDefault();
// });
// document.onkeyup = function (e) {
//   if (process.env.VUE_APP_ROOT_inspect == window.location.search)
//     sessionStorage.setItem("VUE_APP_ROOT_inspect", process.env.VUE_APP_ROOT_inspect);

//   if (
//     sessionStorage.getItem("VUE_APP_ROOT_inspect") == process.env.VUE_APP_ROOT_inspect ||
//     session.isTeacher() ||
//     session.isAdmin()
//   ) {
//   } else {
//     //if (e.ctrlKey) {
//     //    return false;
//     //}

//     if (e.altKey) {
//       return false;
//     }

//     if (e.keyCode == 123) {
//       return false;
//     }
//     if (e.ctrlKey && e.shiftKey && e.keyCode == "I".charCodeAt(0)) {
//       return false;
//     }
//     if (e.ctrlKey && e.shiftKey && e.keyCode == "C".charCodeAt(0)) {
//       return false;
//     }
//     if (e.ctrlKey && e.shiftKey && e.keyCode == "J".charCodeAt(0)) {
//       return false;
//     }
//     if (e.ctrlKey && e.keyCode == "U".charCodeAt(0)) {
//       return false;
//     }
//     if (e.ctrlKey && e.keyCode == "C".charCodeAt(0)) {
//       return false;
//     }
//     if (e.ctrlKey && e.keyCode == "J".charCodeAt(0)) {
//       return false;
//     }
//     if (e.ctrlKey && e.keyCode == "S".charCodeAt(0)) {
//       return false;
//     }
//   }
// };
// document.onkeydown = function (e) {
//   if (process.env.VUE_APP_ROOT_inspect == window.location.search)
//     sessionStorage.setItem("VUE_APP_ROOT_inspect", process.env.VUE_APP_ROOT_inspect);

//   if (
//     sessionStorage.getItem("VUE_APP_ROOT_inspect") == process.env.VUE_APP_ROOT_inspect ||
//     session.isTeacher() ||
//     session.isAdmin()
//   ) {
//   } else {
//     //if (e.ctrlKey)
//     //    return false;

//     if (e.altKey) return false;

//     if (e.keyCode == 123) {
//       return false;
//     }
//     if (e.ctrlKey && e.shiftKey && e.keyCode == "I".charCodeAt(0)) {
//       return false;
//     }
//     if (e.ctrlKey && e.shiftKey && e.keyCode == "C".charCodeAt(0)) {
//       return false;
//     }
//     if (e.ctrlKey && e.shiftKey && e.keyCode == "J".charCodeAt(0)) {
//       return false;
//     }
//     if (e.ctrlKey && e.keyCode == "U".charCodeAt(0)) {
//       return false;
//     }
//     if (e.ctrlKey && e.keyCode == "C".charCodeAt(0)) {
//       return false;
//     }
//     if (e.ctrlKey && e.keyCode == "J".charCodeAt(0)) {
//       return false;
//     }
//     if (e.ctrlKey && e.keyCode == "S".charCodeAt(0)) {
//       return false;
//     }
//   }
// };
// document.addEventListener("copy", function (e) {
//   if (
//     sessionStorage.getItem("VUE_APP_ROOT_inspect") == process.env.VUE_APP_ROOT_inspect ||
//     session.isTeacher() ||
//     session.isAdmin()
//   ) { } else {
//     e.preventDefault();
//     e.clipboardData.setData("text/plain", "Do not copy this site's content!");
//   }
// });
</script>

<style>
:root {
  --primary: #1b3970;
  --secondary: #ffffff;
  --accent: #bc955c;
  --main-font: 'Open Sans', sans-serif;
}

body {
  font-family: var(--main-font) !important;
}

.simulation-ver {
  padding: 5px;
  background-color: #ffffffba;
  font-size: 0.9rem;
}

table>tbody>tr.v-data-table__expanded.v-data-table__expanded__content {
  box-shadow: none !important;
  border-left: 2px solid var(--primary);
  border-top: 2px solid var(--primary);
}
</style>
